"use strict";

require("../../style/default.css");
require("./index.css");
require("../../tooltip/style/css");